export const MAXIMUM_MONTHS = 12;

export const REASON_FIELD = 'snooze_reason';
export const SELECTED_LISTING_IDS_FIELD = 'boats';

export const SNOOZE_REASONS = {
  MAINTENANCE: 0,
  SEASONAL: 1,
  OUT_OF_OFFICE: 2,
  OTHER: 3,
} as const;

export const SNOOZE_SECTION = null; // default section
export const LISTING_SELECTOR_SECTION = 'listing-selector';
export const CALENDAR_SECTION = 'calendar';
export const WIZARD_SECTIONS = [
  SNOOZE_SECTION,
  LISTING_SELECTOR_SECTION,
  CALENDAR_SECTION,
] as const;
